import React from "react";
import styled, { css } from "styled-components";
import Paragraph from "./Paragraph"

const Lead = styled(Paragraph)`
  font-size: ${({ theme }) => theme["size-lead"]};
`;

export default Lead;
